import Layout from "../../components/Layout/Layout";
import Button from "../../components/Button/Button";
import PageTitle from "../../components/PageTitle/PageTitle";
import ButtonCount from "../../components/ButtonCount/ButtonCount";
import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { TableSearch } from "../../components/Table/TableActions";
import Table from "../../components/Table/Table";
import { Grid } from "@mui/material";
import InputGroup from "../../components/FormComponent/InputGroup";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Modal from "../../components/Modal";
import { httprequest } from "../../data/api";
import { ToastContainer, toast } from "react-toastify";
import useStyles from "./styles";
import { Countries } from "../../utils/DropDown";
import SelectGroup from "../../components/FormComponent/SelectGroup";
import useWindowSize from "../../hooks/useWindow";

// Dummy Data
// import SchoolsData from "../../dummy_data/schools.json";

// -- SCHOOL ENDPOINT
const SCHOOLS_ENDPOINT = "/admin/v1/schools";

const Schools = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchResult, setSearchResult] = useState([]);
  const [isSchoolFetching, setIsSchoolFetching] = useState(false);
  const [schoolData, setSchoolData] = useState([]);
  const [addschoolmodal, setAddSchoolModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleAddSchoolModal = () => {
    setAddSchoolModal(!addschoolmodal);
  };

  const [signUpForm, setSignupForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    school_name: "",
    country: ""
  });

  const { first_name, last_name, email, school_name, country } = signUpForm;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSignupForm({ ...signUpForm, [name]: value });
  };

  const getAllSchools = () => {
    setIsSchoolFetching(true);
    httprequest.get(SCHOOLS_ENDPOINT).then((res) => {
      setIsSchoolFetching(false);
      // eslint-disable-next-line no-console
      console.log(res?.data?.data?.schools);

      setSchoolData(res?.data?.data?.schools);
      setSearchResult(res?.data?.data?.schools);
    }).catch((err) => {
      setIsSchoolFetching(false);
      toast.error(err?.response?.data);
    });
  };

  const handleSchool = (e) => {
    e.preventDefault();
    setIsLoading(true);
    httprequest.post(SCHOOLS_ENDPOINT, { schools: [signUpForm] }).then(() => {
      setIsLoading(false);
      toast.success("Account Created Successfully");
      setAddSchoolModal(!addschoolmodal);
      getAllSchools();
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    });
  };

  const checkRowSelected = (selected) => {
    if (selected.selectedRows.length > 0) {
      setIsRowSelected(true);
      setSelectedRows(selected.selectedRows);
    } else {
      setIsRowSelected(false);
      setSelectedRows([]);
    }
  };
  const exportToExcel = () => {
    if (selectedRows.length === 0) {
      toast.error("Please select at least one school to export");

      return;
    }

    try {
      // Prepare data for export
      const exportData = selectedRows.map(row => ({
        "school_name": row.school_name,
        "email": row.email,
        "phone_number": row?.phone_number || "N/A",
        "school_admin": `${row?.school_admin?.first_name || ""} ${row?.school_admin?.last_name || ""}`.trim() || "N/A"
      }));

      const headers = ["School Name", "Email", "Phone Number", "School Admin"];
      const csvContent = [
        headers.join(","),
        ...exportData.map(row => `"${row.school_name}","${row.email}","${row.phone_number}","${row.school_admin}"`
        )
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", `schools_export_${new Date().toISOString().split("T")[0]}.csv`);
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success(`Exported ${selectedRows.length} school(s) successfully`);
    } catch (error) {
      toast.error("Failed to export data");
    }
  };

  const width = useWindowSize();
  const mobile = width < 600;

  const columns = [
    {
      name: "School Name",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">School Name</p>}
          {row?.school_name}
        </>
      )
    },
    {
      name: "Email",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Email</p>}
          {row?.email}
        </>
      )
    },
    {
      name: "School Admin",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">School Admin</p>}
          {`${row?.school_admin?.first_name} ${row?.school_admin?.last_name}` || "N/A"}
        </>
      )
    },
    {
      name: "No of Employees",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">No of Employees</p>}
          {row?.no_of_employees}
        </>
      )
    },
    {
      name: "No of Students",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">No of Students</p>}
          {row?.no_of_students}
        </>
      )
    },
    {
      name: "No of Teachers",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">No of Teachers</p>}
          {row?.no_of_teachers}
        </>
      )
    },
    {
      name: "Registration Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Registration Date</p>}
          {row?.registration_date?.substring(0, 10)}
        </>
      )
    },
    {
      name: "Phone Number",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Phone Number</p>}
          {row?.phone_number || "N/A"}
        </>
      )
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button onClick={ () => navigate(`/schools/${row?.school_id}`)} className="table-action-icon">
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }
  ];

  useEffect(() => {
    // The data will be from the Schools get api endpint
    getAllSchools();
  }, []);

  // --| Filter Shelf21 table using name, email and class
  const handleAdminSchools = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = schoolData?.filter((data) => valArray?.every(
      (word) => data?.school_name?.toLowerCase().includes(word.toLowerCase()) ||
        data?.email?.toLowerCase().includes(word.toLowerCase()) ||
        (data?.school_admin?.first_name?.toLowerCase().includes(word.toLowerCase()) ||
         data?.school_admin?.last_name?.toLowerCase().includes(word.toLowerCase()))
    ));
    setSearchResult(result);
  };

  return (
    <Layout
      children={
        <>
          <PageTitle
            title="Schools"
            subtitle="See how your users interact with your product."
            button={
              <Button
                variant="primary"
                buttonSize="fluid"
                color="btndefault"
                onClick={handleAddSchoolModal}
                buttonName={<div className="flex align-items-center gap-5"><span><AddCircleOutlineIcon /></span>Add a new school</div>}
              />
            }
          />
          <div className={classes.pageContent}>
            <div className="button-count-container">
              <ButtonCount title="School Count" count={schoolData?.length} />
            </div>
            <Table handleRowSelected={checkRowSelected} data={searchResult} columns={columns} subHeader={true} pagination isLoading={isSchoolFetching}
              subHeaderComponent={
                <div className="action_div">
                  <TableSearch placeholder="Search here..." searchTableFunc={handleAdminSchools} />
                  {isRowSelected && (
                    <div className="export-buttons">
                      <Button
                        variant="primary"
                        buttonSize="fluid"
                        color="btndefault"
                        onClick={exportToExcel}
                        buttonName={`Export Selected (${selectedRows.length})`}
                        style={{ marginRight: "10px" }}
                      />
                    </div>
                  )}
                </div> }
            />
          </div>
          {/* CREATE School Info */}
          <Modal
            title="Onboard A New School"
            subtitle={
              <div>Send a school an invite to be a part of Shelf21.
              </div>}
            modalContent={
              <>
                <Grid container spacing={2} className="input-padding">
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="First Name"
                      inputValue={first_name}
                      onChange={handleChange}
                      margin="normal"
                      inputName="first_name"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={6} md={6} sm={6} xs={12}>
                    <InputGroup
                      label="Last Name"
                      inputValue={last_name}
                      onChange={handleChange}
                      margin="normal"
                      inputName="last_name"
                      inputType="text"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="Email Address"
                      inputValue={email}
                      onChange={handleChange}
                      margin="normal"
                      inputName="email"
                      inputType="email"
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <SelectGroup label="Country" children={
                      <select onChange={handleChange} name="country" defaultValue={country}>
                        <option>---Select Country---</option>
                        {Countries.map((country, i) => {
                          return (
                            <option key={i} value={country.Iso2}>{country.name}</option>
                          );
                        })}
                      </select>
                    }
                    />
                  </Grid>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <InputGroup
                      label="School Name"
                      inputValue={school_name}
                      onChange={handleChange}
                      margin="normal"
                      inputName="school_name"
                      inputType="text"
                    />
                  </Grid>
                </Grid>
              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button buttonName="Cancel" buttonSize="full" color="btnfontprimary" variant="primaryoutline" />
                  <Button
                    variant="primary"
                    buttonSize="full"
                    color="btndefault"
                    onClick={handleSchool}
                    buttonName="Send Invite"
                    isLoading={isLoading}
                  />
                </div>
              </>
            }
            isopen={addschoolmodal}
            closeModal={handleAddSchoolModal}
          />
          {/* Delete Modal */}
          {/* <Modal
            title="Off board School"
            subtitle={
              <div>Are you sure you want to off board <span className="modal-name-highlight">{currentRow?.school_name}</span>.If leave off boarded, school will no longer have access to this platform.`
              </div>}
            modalContent={
              <>

              </>
            }
            modalFooter={
              <>
                <div className="flex gap-10">
                  <Button
                    variant="dangeroutline"
                    buttonSize="full"
                    color="btndanger"
                    buttonName="Cancel"
                    onClick={handleDeleteModal}
                  />
                  <Button onClick={handleOffboardSchool} variant="danger" buttonName="Off Board School" buttonSize="full" color="btndefault" />
                </div>
              </>
            }
            isopen={deleteModal}
            closeModal={handleDeleteModal}
          /> */}
          <ToastContainer />
        </>
      }
    />
  );
};

export default Schools;
